(() => {
  const selectors = [
    '#cbb-frequently-bought-container',
    '.cbb-frequently-bought-container',
    '[id*="frequently-bought-container"]',
    '[class*="frequently-bought-container"]'
  ];

  function placeFrequentlyBoughtTogether() {
    if (!document.body.classList.contains('template-product')) return false;

    const bundle = document.querySelector(selectors.join(','));
    const product = document.querySelector('[id^="MainProduct-"]');
    const productSection = product && product.closest('.shopify-section');

    if (!bundle || !productSection || bundle.dataset.gosPlacementComplete === 'true') {
      return false;
    }

    productSection.insertAdjacentElement('afterend', bundle);
    bundle.dataset.gosPlacementComplete = 'true';
    return true;
  }

  if (!placeFrequentlyBoughtTogether()) {
    const observer = new MutationObserver(() => {
      if (placeFrequentlyBoughtTogether()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }
})();
